import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { userActions } from '../../store/user/userSlice';
import { clearAuthContextStorage } from '../../store/user/userService';
import AppHeader from '../../components/AppHeader';
import { basePathForKind, useOrgKind, vocabularyForKind } from '../../pages/team-admin/vocabulary';

// Shared shell for the organization admin screens. Mounted at both
// /team-admin (agencies) and /club-admin (clubs); the nav follows the
// organization kind so a club admin never sees "/team-admin" links.
export const TeamAdminLayout = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const kind = useOrgKind();
  const base = basePathForKind(kind);
  const v = vocabularyForKind(kind);

  const navItems = [
    { to: `${base}/dashboard`, label: v.nav.overview },
    { to: `${base}/players`, label: v.nav.players },
    { to: `${base}/settings`, label: v.nav.settings },
  ];

  const handleLogout = () => {
    localStorage.removeItem('token');
    clearAuthContextStorage();
    dispatch(userActions.setToken(''));
    dispatch(userActions.clearAuthContext());
    navigate('/login', { replace: true });
  };

  return (
    <Shell>
      <AppHeader items={navItems} onLogout={handleLogout} />
      <Content>
        <Outlet />
      </Content>
    </Shell>
  );
};

export default TeamAdminLayout;

const Shell = styled.div`
  min-height: 100vh;
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
  background: ${(props) => props.theme.black};
  color: ${(props) => props.theme.white};
`;

const Content = styled.main`
  flex: 1;
  padding: 24px;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;
`;
